<template>
  <div>
    <JsonEditorVue
        v-model="val"
        mode="text"
        :onRenderMenu="onRenderMenu"
        :style="editor_height"
        :readOnly="readOnly"
        class="jse-theme-dark"
      />
  </div>
</template>

<script>
import Vue from 'vue'
import VCA from '@vue/composition-api'
import JsonEditorVue from 'json-editor-vue'


Vue.use(VCA)

export default {
	components: { JsonEditorVue },
  props: {
    value: {
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    fullscreen: {
    	type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
  	onRenderMenu(items, context) {

  		items = _.drop(items,4);
  		if(!this.fullscreen) {
	  		items.push({
				  onClick: () => {
				  	this.$emit("toggleFullscreen", true);
				  },
				  text: "Fullscreen",
				  type: "button",
				  className: "js-fullscreen"
				});
	  	} else {
	  		items.push({
	  			onClick: () => {
	  				this.$emit("toggleFullscreen", false);
	  			},
	  			text: "Close",
	  			type: "button",
	  			className: "js-fullscreen-close"
	  		});
	  	}
  		return items;
  	}
  },
  computed: {
  	val: {
  		get() {
  			return this.value
  		},
  		set(newVal) {
  			this.$emit("input", JSON.parse(newVal));
  		}
  	},
    editor_height () {
    	if (this.fullscreen) return {height: "100vh"}
      if (typeof(this.height) != "undefined") return "height: " + this.height + "px";
      return "height: 400px";
    }
  }
}
</script>

<style>
.js-fullscreen {
	width: 100px !important;
}
.js-fullscreen-close {
	width: 60px !important;
}
</style>
